"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Debug = require("../context/Debug");

var _formik = require("formik");

var _forms = require("../utils/forms");

var _logger = _interopRequireDefault(require("../utils/logger"));

var _excluded = ["formInput", "children", "onSubmit", "debug"];

var Form = function Form(_ref) {
  var formInput = _ref.formInput,
      children = _ref.children,
      onSubmit = _ref.onSubmit,
      debug = _ref.debug,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var submitFunc = (0, _forms.formSubmit)(onSubmit);
  var logger = (0, _logger["default"])({
    isOn: debug
  });
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, (0, _extends2["default"])({
    onSubmit: submitFunc
  }, rest), function (props) {
    // TODO prevent showing if accidentally pushed to prod
    logger.group('Form state');
    logger.debug(props);
    logger.groupEnd();
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, formInput, /*#__PURE__*/_react["default"].createElement(_Debug.DebugProvider, {
      value: {
        debug: debug
      }
    }, typeof children === 'function' ? children(props) : children));
  });
};

Form.propTypes = {
  /** If `true`, autocomplete will be turned off. */
  disableAutoComplete: _propTypes["default"].bool,

  /** The content of the component. */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,

  /** If `true`, HTML5 validation will be applied. */
  validate: _propTypes["default"].bool,

  /** Submit event for the form. */
  onSubmit: _propTypes["default"].func.isRequired,

  /** Submit event for the form. */
  initialValues: _propTypes["default"].object,
  // For development purposes
  debug: _propTypes["default"].bool
};
Form.defaultProps = {
  validate: false,
  disableAutoComplete: false,
  initialValues: {},
  debug: false
};
var _default = Form;
exports["default"] = _default;